import React from "react";
import { IconProps } from "../icon";
import { createIcon } from "../util/create-icon";
// import "../style/css";

const DiscountIcon: React.ForwardRefExoticComponent<
  IconProps & React.RefAttributes<SVGSVGElement>
> = /*#__PURE__*/ createIcon(
  "discount",
  "DiscountIcon",
  ["currentColor","white"],
  (colorList) => <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16"><g fill="none"><g clipPath="url(#clip0_19498_1373)"><path d="M7.25187 15.3468L0.652203 8.74717L7.39999 2.0103L13.9998 1.99883L13.9998 8.6098L7.25187 15.3468ZM7.25263 13.462L12.6665 8.05688L12.6665 3.33448L7.9526 3.34267L2.53858 8.74794L7.25263 13.462ZM9.99724 6.00253V4.66665H11.3331L11.3332 6.00265L9.99724 6.00253Z" fill={colorList[0]} fillRule="evenodd" clipRule="evenodd" fillOpacity="0.9"/></g><defs><clipPath id="clip0_19498_1373"><rect width="16" height="16" fill={colorList[1]}/></clipPath></defs></g></svg>
);

export default DiscountIcon;
